<template>
  <div class="news-view container" v-if="item">
    <div class="news-view-title">
      <h2>{{ item.title }}</h2>
      <div class="news-view-cate-date">
        <span class="cate">{{ category?.text }}</span>
        <span class="date">{{ $moment(item.date).format("LL") }}</span>
      </div>
    </div>
    <div><img :src="item.image" style="width: 100%" /></div>
    <div class="news-view-content">
      <p v-for="(line, i) in content" :key="i">{{ line }}</p>
    </div>
  </div>
</template>

<script>
export default {
  beforeRouteUpdate(to, form, next) {
    this.load();
    next();
  },
  data() {
    return {
      item: null,
      categories: []
    };
  },
  computed: {
    category() {
      return this.categories.find((c) => c.value == this.item.category);
    },
    content() {
      return (this.item?.content || "").split("\r\n");
    }
  },
  created() {
    this.load();
    this.$axios.post("/news/category", {}).then((data) => {
      this.categories = data.map((c) => {
        return { text: c.name, value: c.id };
      });
    });
  },
  methods: {
    load() {
      this.$axios.post("/news/getItem", { id: this.$route.params.id }).then((data) => {
        this.item = data;
      });
    }
  }
};
</script>

<style lang="scss">
.news-view {
  .news-view-title {
    padding: 16px;
    text-align: center;
    .news-view-cate-date {
      font-size: 14px;
      margin-top: 12px;
      .cate {
        color: var(--background-red);
        margin-right: 12px;
      }
      .date {
        color: #7d7d7d;
      }
    }
    .news-content {
      padding: 24px 12px;
    }
  }
}
@media (min-width: 960px) {
  .news-view {
    .news-view-title {
      padding: 40px 16px;
      h2 {
        font-size: 32px;
      }
    }
  }
}
</style>
